import { useTranslation } from 'react-i18next'
import { Tooltip } from '@pay-com/components'
import { Cloud, CloudChecked, CloudOff, Spinner } from '@pay-com/icons'

export type CloudState = 'idle' | 'saving' | 'saved' | 'synced' | 'error'

const CLOUD_SIZE = 32
const CLOUD_COLOR = '#9999B9'
const CLOUD_COLOR_GREEN = '#8FD157'

const CloudIcon = ({ cloudState }: { cloudState: CloudState }) => {
  switch (cloudState) {
    case 'saving':
      return (
        <div className="relative">
          <Cloud width={CLOUD_SIZE} fill={CLOUD_COLOR} />
          <Spinner
            width={11}
            className="absolute right-2.5 top-[0.715rem]"
            color={CLOUD_COLOR}
          />
        </div>
      )
    case 'saved':
      return <CloudChecked width={CLOUD_SIZE} fill={CLOUD_COLOR_GREEN} />
    case 'error':
      return <CloudOff width={CLOUD_SIZE} fill={CLOUD_COLOR} />
    case 'idle':
    case 'synced':
    default:
      return <Cloud width={CLOUD_SIZE} fill={CLOUD_COLOR} />
  }
}

type CloudSaveIndicatorProps = {
  cloudState: CloudState
}

export const CloudSaveIndicator = ({ cloudState }: CloudSaveIndicatorProps) => {
  const { t } = useTranslation()

  return (
    <Tooltip
      tooltipContent={<p className="text-xs">{t(`cloudSave.${cloudState}`)}</p>}
      variant="dark"
      position="bottom"
    >
      <button type="button" className="h-8" aria-label="Save status">
        <CloudIcon cloudState={cloudState} />
      </button>
    </Tooltip>
  )
}
